import React, { PropsWithChildren } from 'react'

export const Subtitle: React.FC<PropsWithChildren> = ({ children }) => (
  <h4 className="font-body text-darkgray text-sm italic mb-0">
    {children}
  </h4>
)

Subtitle.displayName = 'Card.Subtitle'
